import { EventDrivenStore } from '@core/store/eventDrivenStore';
import { EVENTS } from './constants';

class HomeStore extends EventDrivenStore {
  constructor() {
    const defaultState = {
      stats: {
        data: {
          clientBalance: 0,
          totalTransactions: 0,
          totalCustomers: 0,
          netProfit: 0,
          successfulTransactions: 0,
          failedTransactions: 0
        },
        loading: true,
        error: null
      }
    };
    super('home', defaultState, {
      useLocalStorage: false
    });
  }

  async setupEvents() {
    this.on(EVENTS.HOME.STATS.REFRESHING, () => {
      this.state.stats.loading = true;
      this.state.stats.error = null;
    });

    this.on(EVENTS.HOME.STATS.REFRESHED, (data) => {
      this.state.stats.loading = false;
      this.state.stats.data = data;
    });

    this.on(EVENTS.HOME.STATS.REFRESH_ERROR, (error) => {
      this.state.stats.loading = false;
      this.state.stats.error = error;
    });
  }
}

export default HomeStore;
